// extracted by mini-css-extract-plugin
export default {"wrapper":"small-card_wrapper__46Tuh","boxTitle":"small-card_boxTitle__8Rbke","boxIamge":"small-card_boxIamge__3s37L"};